"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6538],{

/***/ 90714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FY": function() { return /* binding */ getRelatedTags; },
/* harmony export */   "HV": function() { return /* binding */ getAiCharacterSet; },
/* harmony export */   "IZ": function() { return /* binding */ getCharacterList; },
/* harmony export */   "PZ": function() { return /* binding */ getTempCharacter; },
/* harmony export */   "Q1": function() { return /* binding */ getCharacterTags; },
/* harmony export */   "UB": function() { return /* binding */ postCreateVisualCandidateGroups; },
/* harmony export */   "cD": function() { return /* binding */ patchCharacter; },
/* harmony export */   "dA": function() { return /* binding */ releaseCharacter; },
/* harmony export */   "dI": function() { return /* binding */ getCharacterRecommendTags; },
/* harmony export */   "pr": function() { return /* binding */ postCharacter; }
/* harmony export */ });
/* unused harmony export getFreeCharacters */
/* harmony import */ var camelize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94100);
/* harmony import */ var camelize__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(camelize__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45874);
/* harmony import */ var _chatbot__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23082);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



var postCharacter = function() {
    var _ref = _asyncToGenerator(function(payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.post */ .kq.post("playset/", payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data.result
                    ];
            }
        });
    });
    return function postCharacter(payload) {
        return _ref.apply(this, arguments);
    };
}();
var getTempCharacter = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.get */ .kq.get("playset/".concat(id, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data.result
                    ];
            }
        });
    });
    return function getTempCharacter(id) {
        return _ref.apply(this, arguments);
    };
}();
var patchCharacter = function() {
    var _ref = _asyncToGenerator(function(payload, id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.patch */ .kq.patch("playset/".concat(id, "/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data.result
                    ];
            }
        });
    });
    return function patchCharacter(payload, id) {
        return _ref.apply(this, arguments);
    };
}();
var releaseCharacter = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.patch */ .kq.patch("playset/".concat(id, "/release/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data.result
                    ];
            }
        });
    });
    return function releaseCharacter(id) {
        return _ref.apply(this, arguments);
    };
}();
var getAiCharacterSet = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.get */ .kq.get("playset/".concat(id, "/ai-writing/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data.result
                    ];
            }
        });
    });
    return function getAiCharacterSet(id) {
        return _ref.apply(this, arguments);
    };
}();
var getCharacterTags = function() {
    var _ref = _asyncToGenerator(function(query) {
        var withProtected, lastEvaluatedKey, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    withProtected = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true, lastEvaluatedKey = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "";
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.get */ .kq.get("character-tags/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)(_objectSpreadProps(_objectSpread({}, query), {
                            lastEvaluatedKey: lastEvaluatedKey,
                            p: withProtected
                        }))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data === null || data === void 0 ? void 0 : data.result
                    ];
            }
        });
    });
    return function getCharacterTags(query) {
        return _ref.apply(this, arguments);
    };
}();
var getCharacterRecommendTags = function() {
    var _ref = _asyncToGenerator(function() {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.get */ .kq.get("character-tags/recommendations/")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data === null || data === void 0 ? void 0 : data.result
                    ];
            }
        });
    });
    return function getCharacterRecommendTags() {
        return _ref.apply(this, arguments);
    };
}();
var getCharacterList = function() {
    var _ref = _asyncToGenerator(function(query) {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1, perPage = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 20;
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.get */ .kq.get("/characters/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)(_objectSpreadProps(_objectSpread({}, query), {
                            page: page,
                            perPage: perPage
                        }))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data.result
                    ];
            }
        });
    });
    return function getCharacterList(query) {
        return _ref.apply(this, arguments);
    };
}();
var getRelatedTags = function() {
    var _ref = _asyncToGenerator(function(tagId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.get */ .kq.get("/character-tags/".concat(tagId, "/related-tags/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data === null || data === void 0 ? void 0 : data.result
                    ];
            }
        });
    });
    return function getRelatedTags(tagId) {
        return _ref.apply(this, arguments);
    };
}();
var getFreeCharacters = function() {
    var _ref = _asyncToGenerator(function() {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.get */ .kq.get("/character-free-information/")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        camelize__WEBPACK_IMPORTED_MODULE_0___default()(data === null || data === void 0 ? void 0 : data.result)
                    ];
            }
        });
    });
    return function getFreeCharacters() {
        return _ref.apply(this, arguments);
    };
}();
var postCreateVisualCandidateGroups = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_2__/* .CHAT_BOT_API.post */ .kq.post("/playset/".concat(id, "/visual-candidate-group/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        camelize__WEBPACK_IMPORTED_MODULE_0___default()(data === null || data === void 0 ? void 0 : data.result)
                    ];
            }
        });
    });
    return function postCreateVisualCandidateGroups(id) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 73686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FullscreenModalButton; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71618);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96964);
/* harmony import */ var _layout_Push__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23516);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38945);
/* harmony import */ var _Overlay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38632);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          transform: translateY(0);\n          visibility: visible;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n          transform: translateY(100%);\n          visibility: hidden;\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    margin: 0 auto;\n    position: relative;\n    height: 100%;\n    background-color: ",
        ";\n    transition: 0.4s cubic-bezier(0.25, 1, 0.5, 1);\n    will-change: transform;\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  z-index: 9;\n  width: 100%;\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    justify-content: space-between;\n    padding: 0 ",
        "px;\n    height: ",
        "px;\n    ",
        "\n\n    h4 {\n      text-align: center;\n      line-height: ",
        "px;\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  left: ",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  right: ",
        "px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 100%;\n    max-height: inherit;\n    overflow: auto;\n    background-color: ",
        ";\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n  z-index: 9;\n  ",
        "\n\n  @media (max-height: 340px) {\n    display: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}








var fullscreenModalCSS = function(isOpen) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject2(), theme.var.white, isOpen ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject()) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject1()));
    };
};
var headerWrapperCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject3(), theme.var.white, (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("top"));
};
var headerCSS = function(isHideHeaderBorder) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject5(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, _styles_css__WEBPACK_IMPORTED_MODULE_2__/* .MODAL_HEADER_HEIGHT */ .PV, !isHideHeaderBorder && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject4(), theme.border.light), _styles_css__WEBPACK_IMPORTED_MODULE_2__/* .MODAL_HEADER_HEIGHT */ .PV);
    };
};
var headerLeftButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject6(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small);
var headerCloseButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject7(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small);
var contentCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject8(), theme.var.white);
};
var FullscreenModal = function(_param) {
    var title = _param.title, children = _param.children, leftButton = _param.leftButton, rightButton = _param.rightButton, renderButton = _param.renderButton, _hideHeaderBorder = _param.hideHeaderBorder, hideHeaderBorder = _hideHeaderBorder === void 0 ? false : _hideHeaderBorder, className = _param.className, rest = _objectWithoutProperties(_param, [
        "title",
        "children",
        "leftButton",
        "rightButton",
        "renderButton",
        "hideHeaderBorder",
        "className"
    ]);
    var open = rest.open, onClose = rest.onClose;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.u)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Overlay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({}, rest), {
        blocking: false,
        className: className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            css: fullscreenModalCSS(open),
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("header", {
                    css: headerWrapperCSS,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                        css: headerCSS(hideHeaderBorder),
                        children: [
                            leftButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                                css: headerLeftButtonCSS,
                                children: leftButton(theme.var.black)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h4", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                                css: headerCloseButtonCSS,
                                children: rightButton ? rightButton(theme.var.black) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("button", {
                                    className: "icon-btn",
                                    type: "button",
                                    onClick: function() {
                                        return onClose();
                                    },
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Close */ .x8,
                                        color: theme.var.black
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                    css: contentCSS,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_layout_Push__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            top: true,
                            size: _layout_Push__WEBPACK_IMPORTED_MODULE_3__/* .PushSize.header */ .z.header
                        }),
                        children,
                        renderButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_layout_Push__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            bottom: true,
                            size: _layout_Push__WEBPACK_IMPORTED_MODULE_3__/* .PushSize.bottomButton */ .z.bottomButton
                        })
                    ]
                }),
                renderButton === null || renderButton === void 0 ? void 0 : renderButton()
            ]
        })
    }));
};
/** Button */ var fullscreenModalButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject9(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium));
var FullscreenModalButton = function(param) {
    var className = param.className, text = param.text, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        css: fullscreenModalButtonCSS,
        className: className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            text: text,
            disabled: disabled,
            onClick: onClick
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullscreenModal);


/***/ }),

/***/ 86192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n            border: 1px solid ",
        ";\n            background-color: ",
        ";\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n            border: 1px solid ",
        ";\n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: ",
        "px;\n      padding: ",
        "px;\n      cursor: pointer;\n\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var selectableCSS = function(isSelected, padding) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Radius.small */ .wU.small, padding, isSelected ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.colors.main500, theme.colors.main50) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), theme.border.light));
    };
};
var Selectable = function(param) {
    var _selected = param.selected, selected = _selected === void 0 ? false : _selected, _pad = param.pad, pad = _pad === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium : _pad, children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        css: selectableCSS(selected, pad),
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Selectable);


/***/ }),

/***/ 23602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ OuterContent; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: -",
        "px;\n  margin-right: -",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var contentCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium);
var Content = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        css: contentCSS,
        className: className,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Content);
var outerContentCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium);
var OuterContent = function(param) {
    var className = param.className, children = param.children, _style = param.style, style = _style === void 0 ? {} : _style;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        css: outerContentCSS,
        className: className,
        style: style,
        children: children
    });
};


/***/ }),

/***/ 26538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_P": function() { return /* binding */ CharacterTag; }
/* harmony export */ });
/* unused harmony export TagList */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(71618);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54909);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82740);
/* harmony import */ var use_debounce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(57080);
/* harmony import */ var _components_common_Pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39753);
/* harmony import */ var _api_character__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90714);
/* harmony import */ var _base_constants_text__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(49835);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96261);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45874);
/* harmony import */ var _common_Empty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34270);
/* harmony import */ var _common_FullscreenModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73686);
/* harmony import */ var _common_Loading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30208);
/* harmony import */ var _common_Selectable__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86192);
/* harmony import */ var _layout_Content__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23602);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        "px;\n  margin-top: ",
        "px;\n  margin-bottom: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n\n    h5:before {\n      content: '#';\n    }\n\n    small {\n      display: block;\n      font-size: ",
        "px;\n      margin-top: ",
        "px;\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  overflow: hidden;\n  padding: 0 ",
        "px;\n  height: ",
        "px;\n  border: 1px solid ",
        ";\n  border-radius: ",
        "px;\n  margin-top: ",
        "px;\n  margin-right: ",
        "px;\n  font-size: ",
        "px;\n  width: auto;\n  white-space: nowrap;\n\n  span::before {\n    content: '#';\n  }\n\n  i {\n    margin-left: ",
        "px;\n  }\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    white-space: nowrap;\n    overflow: auto;\n    padding: 0 ",
        "px;\n    margin: 0 -",
        "px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  word-break: keep-all;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        "px ",
        "px ",
        "px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


















var subtitleCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xlarge */ .Ki.xlarge);
var qTagCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .FontSizes.xsmall */ .TS.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xxxsmall */ .Ki.xxxsmall, theme.var.gray500);
};
var searchTagListCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject2(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small);
var CharacterSearchTag = function(param) {
    var name = param.name, count = param.count, onClick = param.onClick;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        css: qTagCSS,
        "data-name": name,
        onClick: onClick,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("h5", {
                    className: "ellipsis",
                    children: name
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("small", {
                    children: t("캐릭터 ".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_8__/* .formatComma */ .cO)(count)))
                })
            ]
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var QTagList = function(param) {
    var q = param.q, open = param.open, selectedTags = param.selectedTags, onSelectTag = param.onSelectTag;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var searchTagQuery = (0,_utils_query__WEBPACK_IMPORTED_MODULE_7__/* .useKeyPaginationQuery */ .Z8)([
        "searchTags",
        q
    ], function(param) {
        var pageParam = param.pageParam;
        return (0,_api_character__WEBPACK_IMPORTED_MODULE_6__/* .getCharacterTags */ .Q1)({
            name: q
        }, pageParam);
    });
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        "recommendTags"
    ], _api_character__WEBPACK_IMPORTED_MODULE_6__/* .getCharacterRecommendTags */ .dI), recommendedTags = ref.data;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.Fragment, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("p", {
                css: subtitleCSS,
                children: t("캐릭터와 어울리는 태그를 선택해 주세요.(최대 10개)")
            }),
            q ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_common_Pagination__WEBPACK_IMPORTED_MODULE_5__/* .PaginationIterator */ .gt, {
                        name: "search-tag-list",
                        query: searchTagQuery,
                        margin: true,
                        children: function(item) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_common_Selectable__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                selected: !!selectedTags.find(function(t) {
                                    return t === item.name;
                                }),
                                pad: chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(CharacterSearchTag, {
                                    name: item.name,
                                    count: item.tagged_character_count,
                                    onClick: onSelectTag
                                })
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_common_Empty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        query: searchTagQuery,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("p", {
                                children: t("검색 결과가 없습니다.")
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("p", {
                                children: t("검색창에 태그를 입력한 후 엔터를 눌러 태그를 생성하세요.")
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                css: searchTagListCSS,
                children: recommendedTags === null || recommendedTags === void 0 ? void 0 : recommendedTags.map(function(item) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_common_Selectable__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        selected: !!selectedTags.find(function(t) {
                            return t === item.name;
                        }),
                        pad: chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(CharacterSearchTag, {
                            name: item.name,
                            count: item.tagged_character_count,
                            onClick: onSelectTag
                        })
                    });
                })
            })
        ]
    });
};
var tagCSS = function(theme, height) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject3(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, height !== null && height !== void 0 ? height : 36, theme.border.light, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.small */ .wU.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xxsmall */ .Ki.xxsmall);
};
var CharacterTag = function(param) {
    var name = param.name, edit = param.edit, onClick = param.onClick, height = param.height;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.u)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("button", {
        css: tagCSS(theme, height),
        type: "button",
        className: "icon-text",
        "data-name": name,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("span", {
                children: name
            }),
            edit && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Close */ .x8,
                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Sizes.small */ .u8.small,
                color: theme.var.gray500
            })
        ]
    });
};
var characterTagListCSS = function(isScrollable) {
    return css(_templateObject5(), isScrollable && css(_templateObject4(), Spacing.medium, Spacing.medium));
};
var TagList = function(param) {
    var tags = param.tags, _scroll = param.scroll, scroll = _scroll === void 0 ? false : _scroll;
    return /*#__PURE__*/ _jsx("div", {
        css: characterTagListCSS(scroll),
        children: tags.map(function(tag) {
            return /*#__PURE__*/ _jsx(CharacterTag, {
                name: tag
            }, "tag-".concat(tag));
        })
    });
};
var tagListCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject6(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, theme.border.light);
};
var CharacterTagSelectionModal = function(_param) {
    var handleCreateTag = function handleCreateTag(e) {
        e.preventDefault();
        if (selectedTags.length >= 10) {
            alert(t("태그는 총 10개까지 등록 가능합니다."));
            return;
        }
        var q = e.currentTarget.q.value;
        if (!q) {
            return;
        }
        if (q.length > 20) {
            alert("최대 20글자까지 태그 생성이 가능합니다.");
            return;
        }
        if (selectedTags.some(function(selectedTag) {
            return selectedTag === q;
        })) {
            alert("이미 등록된 태그입니다");
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _base_constants_text__WEBPACK_IMPORTED_MODULE_17__/* .FORBIDDEN_WORD */ .F[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var keyword = _step.value;
                if (q.includes(keyword)) {
                    return alert("해당 태그는 생성이 불가능합니다.");
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setSelectedTags(selectedTags.concat([
            q
        ]));
        clearQ();
    };
    var handleSelectTag = function handleSelectTag(e) {
        var dataset = e.currentTarget.dataset;
        var name = dataset.name;
        if (selectedTags.some(function(tag) {
            return tag === name;
        })) {
            setSelectedTags(selectedTags.filter(function(tag) {
                return tag !== name;
            }));
            return;
        }
        if (selectedTags.length >= 10) {
            alert(t("태그는 총 10개까지 등록 가능합니다."));
            return;
        }
        setSelectedTags(selectedTags.concat([
            name
        ]));
    };
    var handleRemoveTag = function handleRemoveTag(e) {
        var dataset = e.currentTarget.dataset;
        var name = dataset.name;
        setSelectedTags(selectedTags.filter(function(tag) {
            return tag !== name;
        }));
    };
    var submit = function submit() {
        onSelect(selectedTags);
        onClose();
    };
    var onSelect = _param.onSelect, props = _objectWithoutProperties(_param, [
        "onSelect"
    ]);
    var open = props.open, name = props.name, tags = props.tags, onClose = props.onClose;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.u)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), q = ref[0], setQ = ref[1];
    var ref1 = _slicedToArray((0,use_debounce__WEBPACK_IMPORTED_MODULE_18__/* .useDebounce */ .Nr)(q, 300), 2), dQ = ref1[0], dQControl = ref1[1];
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQueryClient)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(tags !== null && tags !== void 0 ? tags : []), selectedTags = ref2[0], setSelectedTags = ref2[1];
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var clearQ = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setQ("");
        dQControl.cancel();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setSelectedTags(tags);
    }, [
        tags
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!open) {
            queryClient.invalidateQueries([
                "searchTags",
                q
            ]);
            setSelectedTags(tags);
            clearQ();
        }
    }, [
        queryClient,
        open
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_common_FullscreenModal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({
        name: "my-story-tag-select"
    }, props), {
        title: t("태그 선택"),
        renderButton: function() {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_common_FullscreenModal__WEBPACK_IMPORTED_MODULE_10__/* .FullscreenModalButton */ .F, {
                text: t("등록하기"),
                disabled: selectedTags.length === 0,
                onClick: submit
            });
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_layout_Content__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("form", {
                    onSubmit: handleCreateTag,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .SearchInput */ .Mj, {
                        ref: inputRef,
                        name: "q",
                        value: q,
                        onChange: function(e) {
                            return setQ(e.currentTarget.value);
                        },
                        onClear: function() {
                            var ref;
                            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                            clearQ();
                        },
                        placeholder: t("캐릭터와 어울리는 태그를 검색해 보세요. (최대 10개)")
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_layout_Content__WEBPACK_IMPORTED_MODULE_13__/* .OuterContent */ .B, {
                    children: selectedTags.length ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        css: tagListCSS(theme),
                        children: selectedTags.map(function(tag) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(CharacterTag, {
                                name: tag,
                                edit: true,
                                onClick: handleRemoveTag
                            }, "".concat(name, "-selected-tag-").concat(tag));
                        })
                    }) : null
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                    fallback: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_common_Loading__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        push: true
                    }),
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(QTagList, _objectSpreadProps(_objectSpread({}, props), {
                        q: dQ,
                        selectedTags: selectedTags,
                        onSelectTag: handleSelectTag
                    }))
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (CharacterTagSelectionModal);


/***/ })

}]);